import Home from "../components/Home/Home";

export default function HomePage() {
  return <Home />;
}
